<template>
    <modal
        ref="feedbackModal"
        :title="`Feedback - ${offer.insurer.name}`"
        :confirmation="false"
        actionText="Close"
    >
        <div class="feedback-message" v-for="feedback in feedbackArray">
            <p style="white-space: pre-line"><b>{{ feedback.isQuery ? 'Query: ' : '' }} {{ feedback.user_name ? feedback.user_name + ',' : '' }} {{ feedback.company_name }}, {{ feedback.date_time }}: </b> "{{ feedback.value }}"</p>
        </div>
    </modal>
</template>

<script>
import Modal from '~/components/Shared/UIComponents/Modal';
import rules from '~/mixins/rules';

export default {
    mixins: [rules],
    components: {Modal},
    props: {
        offer: {
            type: Object,
        }
    },
    data() {
        return {
            newFeedbackValue: undefined,
            isNewFeedbackRequesting: false,
            feedbackList: [],
        }
    },
    created() {
        this.feedbackList = this.offer.feedback;
    },
    watch: {
        "offer.feedback": {
            deep: true,
            handler() {
                this.feedbackList = this.offer.feedback;
            }
        }
    },
    computed: {
        feedbackArray() {
            let feedbackArray = this.feedbackList?.map(feedback => ({
                isQuery: false,
                user_name: feedback.user.name,
                company_name: feedback.user.company.name,
                date_time: this.$moment(feedback.created_at).format('DD/MM/YYYY hh:mm'),
                value: feedback.value
            }));

            if (this.offer.query) {
                feedbackArray.push({
                    isQuery: true,
                    user_name: this.offer.insurer_user?.name, //insurer user may not be present
                    company_name: this.offer.insurer.name,
                    date_time: '', //we don't have this information
                    value: this.offer.query
                });
            }

            return feedbackArray;
        }
    },
    methods: {
        async open() {
            await this.$refs.feedbackModal.open();
        },
    }
}
</script>

<style lang="scss" scoped>
.feedback-message {
    text-align: left;
    margin: 2em 0;

    p {
        font-weight: normal !important;

        b {
            font-weight: 600 !important;
        }
    }
}
</style>
